import {get} from 'lodash';
import {gql} from "@apollo/client";
import client from '../../src/graphql/client';

import refactorHBCData from './multimedia/hero-banner-carousel';
import refactorHBData from './multimedia/hero-banner';
import refactorQuicklinkData from '../data-restructure/navigation/quicklinks/quicklinks';
import refactorImageTextBannerSliderData from '../data-restructure/multimedia/image-text-banner-slider/image-text-banner-slider';
import refactorMultiContentBannerSliderData from '../data-restructure/multimedia/multi-content-banner-slider/multi-content-banner-slider';
import refactorBodyTextData from '../data-restructure/content/body-text/body-text';
import refactorFaqData from '../data-restructure/ui/faqs/faqs';
import refactorTabbedGalleryData from '../data-restructure/multimedia/tabbed-gallery';
import refactorLogoData from '../data-restructure/ui/logos';
import refactorIconTextData from '../data-restructure/ui/icon-text';
import refactorIconTextGridData from '../data-restructure/ui/icon-text-grid';
import refactorImageTextData from '../data-restructure/ui/image-text';
import refactorIconCarouselData from '../data-restructure/ui/icon-carousel';
import refactorCtaBannerData from '../data-restructure/multimedia/cta-banner';
import refactorHBV22023 from '../data-restructure/multimedia/hero-banner-v2-2023';
import refactorImageWithTextV22023 from '../data-restructure/ui/image-with-text-v2-2023';
import refactorMulticontentBannerV22023 from '../data-restructure/multimedia/multi-content-banner-v2-2023';
import refractorRangeCarouselV22023 from '../data-restructure/navigation/range-carousel-v2-2023';
import refractormodelGridV22023 from '../data-restructure/navigation/model-grid-v2-2023';
import refactorEnrichedImageGallery from '../data-restructure/ui/enriched-image-gallery';
import refactorCalculatorBannerData from '../data-restructure/multimedia/calculator-banner';
import refactorAvailableStock from '../data-restructure/content/available-stock';
import refactorFinanceRates from '../data-restructure/data/repayment-calc-rates'

const refactorContentBuilderData = async (data, asTargetObject, keyName, handlebars, pageProps) => {
  const acf_content_builder = asTargetObject ? data : get(data, 'acf_content_builder.contentBuilder', []);
  const key = keyName || 'page'

  let items = [];

  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();

  const rates = refactorFinanceRates(pageProps, countryCode)

  // await acf_content_builder.forEach(async (item, index) => {
  for (var index = 0; index < acf_content_builder.length; index++) {
    const item = acf_content_builder[index];
    if (item) {
      if (item['hbcItemsRep']) {
        items.push({
          type: 'bannerSlider',
          data: refactorHBCData(item['hbcItemsRep'], {
            type: index === 0 ? "largeBanner" : null
          })
        });
      }
      if (item['fieldGroupName'] === `${key}_AcfContentBuilder_ContentBuilder_FcSingleHeroBanner`) {
        items.push({
          type: 'bannerSingle',
          data: refactorHBData(item)
        });
      }
      if (item['fieldGroupName'] === `${key}_AcfContentBuilder_ContentBuilder_FcHeroBannerV22023`) {
        items.push({
          type: 'heroBanner_v2_2023',
          data: refactorHBV22023(item),
          collapseTop: get(item, 'collapseSpacing.top', false),
          collapseBottom: get(item, 'collapseSpacing.bottom', false),
        });
      }
      if (item['fieldGroupName'] === `${key}_AcfContentBuilder_ContentBuilder_FcMultiContentBannerV22023`) {
        items.push({
          type: 'multiContentBanner_v2_2023',
          data: refactorMulticontentBannerV22023(item)
        });
      }
      if (item['fieldGroupName'] === `${key}_AcfContentBuilder_ContentBuilder_FcImageTextV22023`) {
        items.push({
          type: 'imageWithText_v2_2023',
          data: refactorImageWithTextV22023(item)
        });
      }
      if (item['fieldGroupName'] === `${key}_AcfContentBuilder_ContentBuilder_FcRangeCarouselV22023`) {
        items.push({
          type: 'rangeCarousel',
          data: refractorRangeCarouselV22023(item)
        });
      }
      if (item['fieldGroupName'] === `${key}_AcfContentBuilder_ContentBuilder_FcModelGridV22023`) {
        items.push({
          type: 'modelGrid',
          data: refractormodelGridV22023(item)
        });
      }
      if (item['qlItemsRep']) {
        items.push({
          type: 'quicklinks',
          data: refactorQuicklinkData(item)
        });
      }

      if (item['fieldGroupName'] === `${key}_AcfContentBuilder_ContentBuilder_FcHistoryPanel`) {
        items.push({
          type: 'imageTextBannerSlider',
          data: refactorImageTextBannerSliderData(item)
        });
      }

      if (item['ibcItemsRep']) {
        items.push({
          type: 'multiContentBannerSlider',
          data: refactorMultiContentBannerSliderData(item)
        });
      }

      if (item['fieldGroupName'] === `${key}_AcfContentBuilder_ContentBuilder_FcEnrichedImageGallery`) {
        items.push({
          type: 'enrichedImageGallery_v2_2023',
          data: refactorEnrichedImageGallery(item)
        });
      }

      if (item['fieldGroupName'] === `${key}_AcfContentBuilder_ContentBuilder_FcBodyText`) {
        items.push({
          type: 'bodyText',
          data: refactorBodyTextData(item)
        });
      }

      if (item['fieldGroupName'] === `${key}_AcfContentBuilder_ContentBuilder_FcAvailableStock`) {
        items.push({
          type: 'availableStock',
          data: refactorAvailableStock(item),
          rates
        });
      }

      if (item['fieldGroupName'] === `${key}_AcfContentBuilder_ContentBuilder_FcInpageVideo`) {
        items.push({
          type: 'inpageVideo',
          data: get(item, 'ipvVideoUrl', null)
        });
      }

      if (item['fieldGroupName'] === `${key}_AcfContentBuilder_ContentBuilder_FcListingText`) {
        items.push({
          type: 'listingText',
          data: {
            heading: get(item, 'ltHeading', null),
            items: get(item, 'ltItemsRep', []).map(item => {
              return {
                title: get(item, 'ltItemsRepTitle', null),
                content: get(item, 'ltItemsRepBody', null)
              }
            })
          }
        });
      }

      if (item['fieldGroupName'] === `${key}_AcfContentBuilder_ContentBuilder_FcFaqs`) {
        items.push({
          type: 'faqs',
          data: refactorFaqData(item['fcFaqTabsRep'])
        });
      }

      if (item['fieldGroupName'] === `${key}_AcfContentBuilder_ContentBuilder_FcFeatures`) {
        items.push({
          type: 'tabbedGallery',
          data: refactorTabbedGalleryData(item)
        });
      }

      if (item['fieldGroupName'] === `${key}_AcfContentBuilder_ContentBuilder_FcLogos`) {
        items.push({
          type: 'logos',
          data: refactorLogoData(item)
        });
      }

      if (item['fieldGroupName'] === `${key}_AcfContentBuilder_ContentBuilder_FcIconText`) {
        items.push({
          type: 'iconText',
          data: refactorIconTextData(item)
        });
      }

      if (item['fieldGroupName'] === `${key}_AcfContentBuilder_ContentBuilder_FcIconTextGrid`) {
        items.push({
          type: 'iconTextGrid',
          data: refactorIconTextGridData(item)
        });
      }

      if (item['fieldGroupName'] === `${key}_AcfContentBuilder_ContentBuilder_FcImageText`) {
        items.push({
          type: 'imageText',
          data: refactorImageTextData(item)
        });
      }

      if (item['fieldGroupName'] === `${key}_AcfContentBuilder_ContentBuilder_FcIconCarousel`) {
        items.push({
          type: 'iconCarousel',
          data: refactorIconCarouselData(item)
        });
      }
      if (item['fieldGroupName'] === `${key}_AcfContentBuilder_ContentBuilder_FcInpageCtaBanner`) {
        items.push({
          type: 'ctaBanner',
          data: refactorCtaBannerData(item)
        });
      }
      if (item['fieldGroupName'] === `${key}_AcfContentBuilder_ContentBuilder_FcCalculatorBanner`) {
        items.push({
          type: 'calculatorBanner',
          data: await refactorCalculatorBannerData(item)
        });
      }
      if (item['fieldGroupName'] === `${key}_AcfContentBuilder_ContentBuilder_FcForm`) {
        items.push({
          type: 'staticlyForm',
          data: await getFormData(item)
        });
      }
      // JAY26591 2024 SEO Updates = added 'H Tag' (gl_h_tag) ACF field to each Content Builder layout
      if (item['glHTag'] && items.length) {
        items[items.length-1].hTag = item['glHTag'];
        items[items.length-1].data.hTag = item['glHTag'];
      }
    }

  }

  const dealerSiteItems = "{{#template.data}}{{json contentBuilderItems}}{{/template.data}}"

  // Change ! below for dealer site
  // return process.env.DEALER_SITE && (handlebars === undefined || handlebars === true) ? dealerSiteItems.replace(/\n/g,'').replace(/'/g,'"').replace(/\\/g, '').trim() : items;
  return items;
  
}

const getFormData = async (form) => {

  const formId = get(form, 'formId', null)

  const formItem = formId && (await client.query({
    query: gql`
      query GET_STATICLY_FORMS {
        staticlyForms(where: {id: ${parseInt(formId)}}) {
          edges {
            node {
              staticlyFormFields
              staticlyFormId
            }
          }
        }
      }
    `
  }));

  const formRes = get(formItem, 'data.staticlyForms.edges[0].node', null);

  return formRes && formRes.staticlyFormFields ? {
    formData: JSON.parse(formRes.staticlyFormFields),
    formId: formRes.staticlyFormId
  } : {}
}

export default refactorContentBuilderData